import { render, staticRenderFns } from "./DisposeForm.vue?vue&type=template&id=6c7921cc&scoped=true"
import script from "./DisposeForm.vue?vue&type=script&lang=js"
export * from "./DisposeForm.vue?vue&type=script&lang=js"
import style0 from "./DisposeForm.vue?vue&type=style&index=0&id=6c7921cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7921cc",
  null
  
)

export default component.exports